module.exports = {
	"notification.message": "Wix.com utilizza i cookies per offrirti la miglior esperienza possibile.",
	"notification.got.it": "Ok",
	"notification.more.info": "Scopri di più"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_it.json
// module id = 43
// module chunks = 0